import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: Theme.withOpacity(Theme.black, 0.5),
    height: 'auto',
    maxHeight: '100%',
    overflow: 'hidden',
    padding: Theme.px(20),
    position: 'absolute',
    top: Theme.px(20),
    width: '100%',
  },
  text: {
    color: Theme.white,
    textAlign: 'center',
  },
});
